import { FormInput } from "./Common"
import { HayabanOsoban } from "./Shinsei"
import { Syozoku } from "./Syozoku"
import { SyuugyouBasyoOption } from "./SyuugyouBasyo"
import { MeijisyoInfoForTimeSheet } from "./SyuugyouJoukenMeijisyo"

// 各種打刻実行時のリクエスト
export interface DakokuReq {
  syuugyouBasyoId: number,
  koyouKeiyakuId: number | null,
  koyouKeiyakuTimeId: number | null
}

// 休憩時間の登録リクエスト
export interface KyuukeiReq {
  targetDate: string,
  kyuukeiTimes: string,
  syuugyouBasyoId: number,
  koyouKeiyakuId: number | null,
  koyouKeiyakuTimeId: number | null
}

// 打刻コメントの登録リクエスト
export interface HonninNotesReq {
  targetDate: string,
  honninNotes: string,
  syuugyouBasyoId: number,
  koyouKeiyakuId: number | null,
  koyouKeiyakuTimeId: number | null
}

// 打刻情報取得時のリクエスト
export interface GetDakokuReq {
  syuugyouBasyoId: number,
  koyouKeiyakuId: number | null,
  koyouKeiyakuTimeId: number | null,
}

// 打刻情報取得時のレスポンス
export interface DakokuData {
  dakoku_id: number | null,
  user_id: number | null,
  koyou_keiyaku_id: number | null,
  dakoku_date: Date | string | null,
  koyou_keiyaku_time_id: number | null,
  syukkin_datetime: Date | string | null,
  gaisyutsu_datetime: Date | string | null,
  gaisyutsu_times: string | null,
  modori_datetime: Date | string | null,
  taikin_datetime: Date | string | null,
  is_koukyuu: boolean,
  kyuukei_times: string | null,
  reported_kyuukei_times: string | null,
  syounin_status_type: number | null
  honnin_notes: string | null,
}

// 勤務一覧取得時のリクエスト
export interface GetKinmuListReq {
  syuugyouBasyoId: number | null,
  koyouKeiyakuId: number | null | undefined,
  year: number | null,
  month: number | null,
  dakokuId?: number | null
  targetUserId: number
}

export interface GetKinmuListBySummaryIdReq {
  summaryId: number
}


// 勤務一覧取得時のレスポンス
export interface GetKinmuListResBase {
  userId: number,
  syuugyouBasyoId: number,
  syuugyouBasyo: SyuugyouBasyoOption | null,
  koyouKeiyakuId: number | null,
  start: string,
  end: string,
  year: number,
  month: number,
  userName: string | null,
  dakokuSyouninGroupId: number | null,
  hakenModifies: HakenDakokuData[], // 派遣社員の打刻に総務編集した情報
  staffCode: string | null,
  shimeDay: number,
  hasUncompleteDakoku: boolean,
  hasWaitShinsei: boolean,
  syozokuInfo: Syozoku | null,
  meijisyoInfo: MeijisyoInfoForTimeSheet | null,
  isAfterTaisyokuMonth: boolean
}

// 勤務一覧取得時のレスポンス
export interface GetKinmuListRes extends GetKinmuListResBase {
  list: KinmuListData[]
}

// 勤務一覧取得時のレスポンス（派遣先上長がマイタスクで閲覧するときのデータ）
export interface GetHakenKinmuListRes extends GetKinmuListResBase {
  list: HakenKinmuListData[],
  isClosed: boolean,
  isSendedPx: boolean,
}

// 勤務一覧表示のためのある一日の勤務情報
export interface KinmuListDataBase {
  key: string, // v-for用のキー
  datetime: string | Date, // Dateオブジェクト変換用の日時
  date_for_display: string, // 表示用の日時
  waitShinseis: ShinseiInfo[], // 承認待ちの申請
  shinseis: DakokuInfoShinsei, // 承認済の申請
  hayaban_osoban: HayabanOsoban | null // 早番遅番申請
}

export interface MyTaskKinmuData extends KinmuListDataBase {
  kinmus: DakokuDataFull[], // 勤務情報
  haken: HakenDakokuData[], // 派遣勤務一覧表示のためのある一日の勤務情報
  check: SoumuDakokuCheckData[], // 総務の打刻確認情報
  is_soumu_select: boolean,
}

// 勤務一覧表示のためのある一日の勤務情報
export interface KinmuListData extends KinmuListDataBase {
  kinmus: HakenDakokuData[], // 勤務情報
  is_syounin_select: boolean,
}

// 勤務一覧表示のためのある一日の勤務情報
export interface HakenKinmuListData extends KinmuListDataBase {
  kinmus: HakenDakokuData[], // 勤務情報
}

/**
 * ある一日に含まれる打刻データ（フル／レスポンスまま）
 * 項目は原則DakokuDataFullと対応する（※型はdakokusに準拠）
 */
export interface DakokuDataFull {
  dakoku_id: number,
  user_id: number,
  koyou_keiyaku_id: number,
  koyou_keiyaku_time_id: number | null,
  mst_syuugyou_basyo_id: number,
  dakoku_date: Date | string | null,
  syukkin_datetime: Date | string | null,
  syukkin_round_datetime: Date | string | null,
  gaisyutsu_datetime: Date | string | null,
  gaisyutsu_round_datetime: Date | string | null,
  modori_datetime: Date | string | null
  modori_round_datetime: Date | string | null
  taikin_datetime: Date | string | null
  taikin_round_datetime: Date | string | null
  kyuukei_times: string | null
  kyuukei_round_times: string | null
  syotei_work_times: string | null,
  koujo_times: string | null,
  houteinai_zangyou_times: string | null,
  jikangai_work_times: string | null,
  shinya_warimashi_times: string | null,
  chikoku_times: string | null,
  soutai_times: string | null,
  is_yuukyuu: boolean,
  yuukyuu_tani_type: number,
  is_kekkin: boolean,
  is_kibiki: boolean,
  kibiki_tani_type: number,
  is_furide: boolean,
  is_furikyuu: boolean,
  furikyuu_tani_type: number,
  is_kosyoku_teate: boolean,
  is_nittyoku_teate: boolean,
  is_kiken_teate: boolean,
  is_hannichi_hosei: boolean,
  syounin_status_type: number, // 1:承認待ち 2:承認済 3:否認済
  syounin_status_notes: string, // 否認理由
  is_saishin: boolean,
  honnin_notes: string | null, // 本人コメント
  soumu_change_user_id: number | null,
  yuukyuu_times: string | null,
  isUncomplete?: boolean,
  isNeedKyuukei?: boolean,
  isKoujyoZangyouSousai?: boolean,
}

export interface DakokuDataFullWithSyuugyouBasyoName extends DakokuDataFull {
  syuugyou_basyo_name: string
}

export interface GetKintaiSummaryReq {
  syuugyouBasyoId: number,
  koyouKeiyakuId: number | null,
  userId: number | null,
  year: number,
  month: number
}

export interface GetKintaiSummaryRes {
  summary: KintaiSummaryData
  start: string,
  end: string,
  syuugyouBasyoId: number,
  koyouKeiyakuId: number | null,
}

/**
 * ある期間中の集計済みの勤怠サマリー（クライアント内で使用する形式）
 * 項目は原則KintaiSummaryDataと対応する（※型はkintai_summariesに準拠）
 */
export interface KintaiSummaryData {
  kintai_summary_id: number
  user_id: number | null
  koyou_keiyaku_id: number | null
  mst_syuugyou_basyo_id: number | null
  buka_id: number,
  start_date: Date | string | null
  end_date: Date | string | null
  heijitsu_syukkin_days: number | null
  cyousei_notes: string | null
  nittyoku_count: number | null
  syukkin_times: string | null
  chikoku_count: number | null
  soutai_count: number | null
  kyuujitsu_syukkin_days: number | null
  yuukyuu_days: number | null
  daikyuu_days: number | null
  sonota_kyuujitsu_days: number | null
  seiri_kyuuka_days: number | null
  kyuusyoku_days: number | null
  kekkin_days: number | null
  koukyuu_days: number | null
  koujo_times: string | null
  houteinai_zangyou_times: string | null
  zangyou_times: string | null
  shinya_zangyou_times: string | null
  kyuujitsu_zangyou_times: string | null
  kyuujitsu_shinya_zangyou: string | null
  shinya_warimashi_times: string | null
  syotei_work_days: number | null
  syotei_work_times: string | null
  soutai_times: string | null
  chikoku_times: string | null
  syounin_status_type: number | null
  syounin_datetime: Date | string | null
  syounin_user_name: string | null
  syounin_user_yakusyoku: string | null
  is_px: boolean
  zangyou_sashihiki_times: string | null
  shinya_zangyou_sashihiki_times: string | null
  kyuujitsu_zangyou_sashihiki_times: string | null
  kyuujitsu_shinya_zangyou_sashihiki_times: string | null
  houkatsu_times: string | null // 包括時間（雇用契約テーブルより）※デバッグ用
}

export interface DakokuSyouninReq {
  dakokuId: number,
  syouninStatusType: number
  syouninStatusNotes: string
}

export interface DakokuSyouninRes {
  result: boolean
}

export interface MyTaskData extends DakokuDataFull {
  is_manager_select: boolean,
  is_soumu_select: boolean,
  is_haken: boolean,
  staff_code: number,
  staff_name: string,
  check_user_id: number,
  syuugyou_basyo_name: string | null,
  list: MyTaskKinmuData[],
  kintai_summary_id: number | null,
  mst_syounin_group_id: number,
  start: string,
  end: string,
  shimeDay: number,
  index: number,
}

export interface MyTaskDakokuData extends DakokuDataFull {
  is_manager_select: boolean,
  is_soumu_select: boolean,
  is_haken: boolean,
  staff_code: number,
  staff_name: string,
  check_user_id: number,
  syuugyou_basyo_name: string | null,
  waitShinseis: ShinseiInfo[], // 承認待ちの申請
  shinseis: DakokuInfoShinsei, // 承認済の申請
  isUncomplete: false, // 打刻が不完全か
}

export interface DakokuDetailData extends DakokuDataFull {
  is_koukyuu: boolean,
  staff_name: string,
  syuugyou_basyo_name: string | null,
}

// 総務の打刻確認情報
export interface SoumuDakokuCheckData {
  // checkedUserName?: string,
  datetime: string | Date, // Dateオブジェクト変換用の日時
}

// 派遣勤務一覧表示のためのある一日の勤務情報
export interface HakenDakokuData extends DakokuDataFull {
  modifiedKinmuTimes: string,
  soumu_note1: string | null, // 総務記入1
  soumu_note2: string | null, // 総務記入2
}

// 派遣勤務一覧表示のためのある一日の勤務情報
export interface SetSoumuModifyData {
  dakoku_date: string | Date,
  soumu_note1: string | null, // 総務記入1
  soumu_note2: string | null, // 総務記入2
}



export interface HakenModifyDatas {
  user_id: number,
  koyou_keiyaku_id: number,
  mst_syuugyou_basyo_id: number,
  modifies: SetSoumuModifyData[] // 勤務情報
}

export interface CloseKintaiSummaryReq {
  kintaiSummaryId: number,
  comment: string | null,
  dakokuSyouninGroupId: number | null,
  syouninUserName: string | null,
  syouninUserYakusyoku: string | null
}

export interface CloseCancelKintaiSummaryReq {
  kintaiSummaryId: number
}

export class KinmuListInfo {
  syuugyouBasyo: SyuugyouBasyoOption | null = null // ここに就業場所IDと雇用契約IDを含んでいる
  userId: number | null = null
  year: number | null = null
  // year: number = new Date().getFullYear()
  month: number | null = null
  // month: number = new Date().getMonth() + 1
  start: string | Date | null = null
  end: string | Date | null = null
  userName: string | null = null
  dakokuSyouninGroupId: number | null = null
  staffCode: string | null = null
  hasUncompleteDakoku: boolean = false
  hasWaitShinsei: boolean = false
  syozokuInfo: Syozoku | null = null
  meijisyoInfo: MeijisyoInfoForTimeSheet | null = null
}

// 打刻情報取得時の申請情報
export interface DakokuInfoShinsei {
  hayabanOsoban: ShinseiInfo[],
  koukyuu: ShinseiInfoKoukyuu[],
  jikangai: ShinseiInfoJinkaigai[],
  kyuukei: ShinseiInfoKyuukeiJinkaigai[], // 休憩未取得（旧・休憩時間外／休憩残業）のこと
  furikyuu: ShinseiInfoFurikyuuFuride[],
  yuukyuu: ShinseiInfoYuukyuu[],
  kekkin: ShinseiInfoKekkin[],
  soutai: ShinseiInfo[],
  chikoku: ShinseiInfo[],
  nittyoku: ShinseiInfoNittyoku[],
  kibiki: ShinseiInfoKibiki[],
  hannichiHosei: ShinseiInfo[],
  syuusei: ShinseiInfo[],
}

export interface DakokuInfoShinseiForSoumuSyuusei extends DakokuInfoShinsei {
  // MEDICA_AS-1202により総務修正のみ振休・振出申請を別々で扱うため分けている
  // DakokuInfoShinseiに入れてしまうと打刻修正など他の部分に影響が出るため
  furide: ShinseiInfoFurikyuuFuride[],
}

// 打刻情報取得時の申請情報
export interface ShinseiInfo {
  id: number,
  shinsei_type: number | null,
  date: string | Date,
  notes: string,
  syounin_status_type: number,
  koyou_keiyaku_id: number,
  mst_syuugyou_basyo_id: number,
  user_id: number,
}

// 打刻一覧取得時に勤務情報についてくる申請情報の詳細部（総務修正用）
// 総務修正用 共通
export interface ShinseiInfoDetail {
  id: number,
  shinsei_type: number | string // 通常typeはnumberだがここでは公休と早番遅番がそれぞれkoukyuu／hayaban_osobanとして返ってくることがあるためstringも定義している
}

// 総務修正用 公休
export interface ShinseiInfoKoukyuu extends ShinseiInfo {
  detail: ShinseiInfoDetailKoukyuu
}

export interface ShinseiInfoDetailKoukyuu extends ShinseiInfoDetail {
  koukyuu_date: string | Date | null,
  koukyuu_tani_type: number | null
}

// 総務修正用 時間外
export interface ShinseiInfoJinkaigai extends ShinseiInfo {
  detail: ShinseiInfoDetailJikangai
}

export interface ShinseiInfoDetailJikangai extends ShinseiInfoDetail {
  jikangai_date: string,
  start_datetime: string,
  start_time: string,
  end_datetime: string,
  end_time: string,
}

// 総務修正用 休憩未取得
export interface ShinseiInfoKyuukeiJinkaigai extends ShinseiInfo {
  detail: ShinseiInfoDetailKyuukeiJikangai
}

export interface ShinseiInfoDetailKyuukeiJikangai extends ShinseiInfoDetail {
  kyuukei_jikangai_date: Date | string | null,
  kyuukei_jikangai_times: string | null,
}

// 総務修正用 振休・振出
export interface ShinseiInfoFurikyuuFuride extends ShinseiInfo {
  detail: ShinseiInfoDetailFurikyuuFuride
}

export interface ShinseiInfoDetailFurikyuuFuride extends ShinseiInfoDetail {
  syukkin_date: Date | string | null,
  syukkin_furidetani_type: number | null,
  start_datetime: string | null,
  start_time: string | null,
  end_datetime: string | null,
  end_time: string | null,
  kyuukei_time: string | null,
  furikyuu1_date: Date | string | null,
  furikyuutani1_type: number | null,
  furikyuu2_date: Date | string | null,
  furikyuutani2_type: number | null,
}

// 総務修正用 有休
export interface ShinseiInfoYuukyuu extends ShinseiInfo {
  detail: ShinseiInfoDetailYuukyuu
}

export interface ShinseiInfoDetailYuukyuu extends ShinseiInfoDetail {
  yuukyuu_tani_type: number | null,
  start_date: Date | string | null,
  yuukyuu_times: string | null,
}

// 総務修正用 欠勤
export interface ShinseiInfoKekkin extends ShinseiInfo {
  detail: ShinseiInfoDetailKekkin
}

export interface ShinseiInfoDetailKekkin extends ShinseiInfoDetail {
  start_date: Date | string | null,
  end_date: Date | string | null,
  kekkin_days: number | null,
}

// 総務修正用 日直
export interface ShinseiInfoNittyoku extends ShinseiInfo {
  detail: ShinseiInfoDetailNittyoku
}

export interface ShinseiInfoDetailNittyoku extends ShinseiInfoDetail {
  shinsei_date: Date | string | null,
}

// 総務修正用 忌引
export interface ShinseiInfoKibiki extends ShinseiInfo {
  detail: ShinseiInfoDetailKibiki
}

export interface ShinseiInfoDetailKibiki extends ShinseiInfoDetail {
  kibiki_start_date: Date | string | null,
  kibiki_tani_type: number | null,
  kibiki_times: string | null,
  kojin_name: string | null,
  kojin_kana: string | null,
  tsuzukigara: string | null,
  sikyo_date: Date | string | null,
}

export interface MyTaskSelectItem {
  user_id: number,
  koyou_keiyaku_id: number,
  mst_syuugyou_basyo_id: number,
  check: MyTaskKinmuData[], // 総務の打刻確認情報
}

export interface boolRes extends FormInput {
  result: boolean,
}

/**
 * 打刻再計算リクエスト（各種情報による指定）
 */
export interface RecalcDakokByDakokuInfouReq {
  force: boolean,
  dakokuInfos: RecalcDakokByDakokuInfo[]
}

export interface RecalcDakokByDakokuInfo {
  userId: number,
  date: string | Date,
  syuugyouBasyoId: number,
  koyouKeiyakuId: number | null,
}

export interface SoumuDakokuCheckListRes {
  allList: MyTaskData[],
  totalDataCount: number,
}
